<template>
  <form-select
      :value="value"
      :options="filteredOrganizationsList"
      :placeholder="$t('label.organization')"
      with-icon
      show-search
      @change="$emit('change', $event)"
      @search="organizationSearchText = $event"
      @blur="organizationSearchText = ''"
  >
    <template #prefix-icon>
      <list-icon/>
    </template>
  </form-select>
</template>

<script>
import {mapGetters} from 'vuex';
import ListIcon from '@/assets/icons/listIcon';
import FormSelect from "@/components/elements/FormSelect.vue";

export default {
  name: 'SearchableOrganizationSelect',
  components: {
    ListIcon,
    FormSelect
  },
  props: {
    value: {}
  },
  data() {
    return {
      organizationSearchText: ''
    };
  },
  computed: {
    ...mapGetters({
      organizationsList: 'organizationsStore/DROPDOWN_LIST'
    }),
    filteredOrganizationsList() {
      if (!this.organizationSearchText) {
        return this.organizationsList;
      }
      const searchLower = this.organizationSearchText.toLowerCase();
      return this.organizationsList.filter(org =>
          org.label.toLowerCase().includes(searchLower)
      );
    }
  }
};
</script>

<style>

</style>